import Axios from 'axios';
import { apiUrl } from 'app/environment-variables';
import { SocialLinksI } from './models';

export const getSocialLinks = () =>
  Axios.get<CommonTypes.RestfulResponse<SocialLinksI>>(
    `${apiUrl}/social-links`,
  );
